module.exports = __webpack_public_path__ + "img/appIcon-menu--Contacts--active.38c3a82e.svg";